import React from "react";
const buttonClass = (isActive) =>
  `px-1.5 py-0.5 text-[11px] leading-4 rounded-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-500 ${
    isActive ? "bg-gray-600 text-gray-100" : "text-gray-400 hover:text-gray-200"
  }`;

const TransformDisplayModeSwitches = ({
  value,
  leftLabel,
  leftValue,
  rightLabel,
  rightValue,
  onChange,
}) => (
  <div className="inline-flex rounded-md border border-gray-700 p-0.5 bg-gray-900/20">
    <button
      type="button"
      className={buttonClass(value === leftValue)}
      onClick={() => onChange(leftValue)}
    >
      {leftLabel}
    </button>
    <button
      type="button"
      className={buttonClass(value === rightValue)}
      onClick={() => onChange(rightValue)}
    >
      {rightLabel}
    </button>
  </div>
);

export default TransformDisplayModeSwitches;
